import styled from 'styled-components';

export const StyledStepMenu = styled.div`
  display: relative;
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(18, 52, 77, 0.16);
  border-radius: 4px;
  padding: 10px;
  margin-left: 200px;

  .step-option {
    cursor: pointer;
    padding: 5px 12px;
    border-radius: 6px;
    display: flex;
    color: var(--color-elephant-800);
    font-size: 16px;
    font-weight: 600;
    align-items: center;
  }

  .icon {
    margin-right: 10px;
  }

  .step-option:hover {
    background: var(--color-azure-50);
  }
`;
